export const DISTRICTS        = ['Upendo','Weema','Furaha','Fadhili','Amani','Uaminifu'];
export const MINISTRIES       = ['Evangelism','JPRC','BSR','Church School','Youth Fellowship','PCMF',"Women's Guild",'Boys & Girls Brigade','Christian Education','Health Committee'];
export const SERVICE_GROUPS   = ['Praise & Worship','Church Choir'];
export const ALL_GROUPS       = [...MINISTRIES, ...SERVICE_GROUPS];
export const MEMBERSHIP_TYPES = ['Full Member','Associate Member','Adherent','Communicant','Baptised Child','Pending'];
export const CONTRIBUTION_TYPES = ['Tithe','Offering','Special','Harvest','Building Fund','Thanksgiving'];
export const FAMILY_ROLES     = ['head','spouse','child','member'];
export const AREAS =['Central','Ngecha','Thingati B','Gatina','Around Church'];

export const fmt     = (n) => 'KES ' + Number(n || 0).toLocaleString();
export const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-KE', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';
export const initials = (m) => ((m?.first_name || m?.firstName || '')[0] + (m?.last_name || m?.lastName || '')[0]).toUpperCase();

export const STATUS_BADGE = {
  active:    'badge-active',
  pending:   'badge-pending',
  inactive:  'badge-inactive',
  suspended: 'badge-inactive',
  deceased:  'badge-deceased',
};
